//
// Module for the Security Administration Users view.
//
rs.module("content/security/administration/users",

    [
        "controls/components/event-banner"
    ],

    function (eventBanner) {

        var _executeSelectionChanged;

        // Initialize the module
        function initialize(jsSelectors, columnIds, backendUrls, usersGridLrsApi) {

            // Unpack js selectors
            var criteria = $.js(jsSelectors.criteria);

            var associationPartial = criteria.js(jsSelectors.associationPartial, { required: false });
            var userGridLoadingSpinner = criteria.js(jsSelectors.userGridLoadingSpinner, { multiple: true });
            var flushLinkButton = criteria.js(jsSelectors.flushLinkButton);

            var modalForm = $.js(jsSelectors.modalForm);

            var modalPopup = modalForm.js(jsSelectors.modalPopup);
            var modalPopupCancelButton = modalForm.js(jsSelectors.modalPopupCancelButton, { multiple: true });

            // On load, if a row is selected - scroll to ensure it is visible.
            if (usersGridLrsApi.agGridApi.getSelectedNodes().length != 0) {
                var firstSelectedRowIndex = usersGridLrsApi.agGridApi.getSelectedNodes()[0].rowIndex;
                usersGridLrsApi.agGridApi.ensureIndexVisible(firstSelectedRowIndex, 'middle');
            }

            // Handle the users grid change event
            usersGridLrsApi.selectionChanged(function (values, rows) {

                // This handler fires when the grid is first rendered, but we don't want it to in our case
                // _executeSelectionChanged will be false the first time it runs, after that this will fire every time a row is clicked
                if (_executeSelectionChanged && values.length > 0) {

                    // Clear event banner
                    eventBanner.removeAllMessages();

                    // Retrieve and update the user associations partial view.
                    getUserAssociations(rows[0][columnIds.username]);
                }

                _executeSelectionChanged = true;
            });

            // Open the Synchronize modal popup.
            flushLinkButton.on('click', function () {

                // Clear event banner
                eventBanner.removeAllMessages();

                modalPopup.modal('show');

            });

            // Handle the modal 'Close' button event.
            modalPopupCancelButton.click(function () {
                modalPopup.modal('hide');
                return false;
            });

            // Retrieve user associations
            function getUserAssociations(username) {

                // Show the metadata spinners
                userGridLoadingSpinner.show();

                // Retrieve Partial View
                $.get(
                    backendUrls.getUserAssociationsAsync, { username: username })
                    .done(function (result) {

                        // Replace Partial
                        associationPartial.html(result);

                        // Hide the metadata spinners
                        userGridLoadingSpinner.hide();
                    });
            }
        }

        // Exported public API
        var exports = {
            initialize: initialize
        };

        return exports;
    }
);